import Connection from '../connection';

const BASE_PATH = '/webex';

export function loadUser() {
  return Connection.send(`${BASE_PATH}/user`);
}

export function loadTeams() {
  return Connection.send(`${BASE_PATH}/teams`);
}

export function updateBlacklist({ removeIds, addIds }) {
  return Connection.send(
    `${BASE_PATH}/channels/blacklist/massUpdate`, {
      removeIds,
      addIds,
    }, 'POST');
}

export function addToBlacklist({ channelId }) {
  return Connection.send(`${BASE_PATH}/channels/blacklist/add`, { channelId }, 'POST');
}

export function removeFromBlacklist({ channelId }) {
  return Connection.send(`${BASE_PATH}/channels/blacklist/remove`, { channelId }, 'POST');
}



// WEBPACK FOOTER //
// ./src/services/api/webex.js